import { Component, OnInit, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { CartService } from 'app/main/services/cart.service';
import { Subject } from 'rxjs';
import { BaseCartDirective } from 'app/main/cart.base';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AppService } from 'app/main/services/app.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'cart-page',
	templateUrl: './shopping-cart.component.html',
	styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartPageComponent extends BaseCartDirective implements OnInit {
	
	@ViewChild('genericError') genericErrror: ElementRef;
	@ViewChildren('couponMsg') couponMsgs: QueryList<ElementRef>;

	public messageCoupons: any;
	public formGroup: FormGroup;
	public _previewing;

	constructor(
		public cartService: CartService, 
		public appService: AppService, 
		private fb: FormBuilder, 
		public translate: TranslateService){
			super(appService, translate, cartService);
		}

	initForm(): void{
		this.formGroup = this.fb.group({
			coupon_code: new FormControl(''),
		});
	}

	ngOnInit(): void {
		window.scroll(0,0);

		super.ngOnInit();
		this.initForm();

		this.cartService.cartData.subscribe(cartData => {
			this.cartData = cartData;
		});
	}

	clearGenericError(): void{
		this.genericErrror.nativeElement.remove();
	}

	onSubmit(): void{
		const couponCode = this.formGroup.get('coupon_code').value;
		this.cartService.applyCoupon(couponCode.split(','))
		.subscribe({
			next: data => {
				this.messageCoupons = data.response;
				this.cartService.setInternalTimer(data.cart);
				this.cartService.cartData.next(data.cart);
				this.formGroup.reset();
				// remove message coupons
				setTimeout(() => this.couponMsgs.forEach((couponMsg: ElementRef) => couponMsg.nativeElement.remove()), 4000);
			},
			error: response => {
				// catch error
			}
		});
	}
}
